import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import ErrorIcon from '@mui/icons-material/Error';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { InputAdornment } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import CheckPermissions from '../../../authorization/authorization';
import { signIn, stopLoading, setUserData } from '../../../features/authentication/authenticationSlice';
import { updateOC } from '../../../features/officeCodeForName/officeCodeForName';
import { fetchInstallmentProvisions } from '../../../features/provisions/installmentProvisions';
import eOpsLogo from '../../../images/eops.png';
import captcha from '../../../images/g3.png';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import { AllSubDivisions } from '../../../network/APIs/APIs';
import { loginSchema } from "../../../schemas/login";
import './login.scss';
import { fetchAuth } from '../../../features/mdm/authorization';
import { Snackbar, Alert } from '@mui/material';
import { Modal, Typography } from '@mui/material';
import * as Yup from "yup";
import { BulkDistributionTheft, damagedMeter, DelayedBillingNewConnection, DetectionBill, electricFire, ElectricityTheft, fluctuation, imageExtensions, InstalledTransformerMeterWireTheft, lineFault, lowVoltageLongTerm, lowVoltageShortTerm, MeterPosition, NonDeliveryofBill, otherComplaintsArray, otherComplaintsArrayCommerical, others, passwordRegex, powerOutage } from '../../../utils/PortalName';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { cfpBaseUrl } from '../../../network/urls';
import Error from "../../../components/error/error";
import MfaStep from './MfaStep';
import {
  shouldShowMfaStep,
  fetchMfaQrSetup,
  verifyMfaOtp,
} from '../../../network/mfaApi';

const Login = () => {

  //#region constants and states
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, token, code, hierarchy, loading, error, permissions, roleTypeId, roleTypeName, roleId,companyCode } = useSelector((state) => state.auth);
  const UserId = userId || localStorage.getItem('userId');
  const [isLoading, setIsLoading] = React.useState(true);
  const [isLocalLoading, setIsLocalLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showError, setShowError] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [userToken, setUserToken] = useState('');
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowOldPassword = () => setShowOldPassword((prev) => !prev);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [apiError, setApiError] = useState('')
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [showMfa, setShowMfa] = useState(false);
  const [pendingLoginData, setPendingLoginData] = useState(null);
  const [mfaQrSrc, setMfaQrSrc] = useState(null);
  const [mfaManualSecret, setMfaManualSecret] = useState('');
  const [mfaQrLoading, setMfaQrLoading] = useState(false);
  const [mfaQrError, setMfaQrError] = useState('');
  const [mfaVerifyLoading, setMfaVerifyLoading] = useState(false);
  const [mfaVerifyError, setMfaVerifyError] = useState('');
  const [mfaUserId, setMfaUserId] = useState('');

  const initialValues = {
    UserName: "",
    Password: "",
    iv_old_password: "",
    iv_new_password: "",
    iv_confirm_password: ""
  };
  const errorCloses = () => {
    // setComplaintsError("");
    setApiError("")
  };

  useEffect(() => {
    if (token && roleTypeId == 1) {
      dispatch(fetchInstallmentProvisions())
    } else if (token && roleTypeId == 2) {
      dispatch(fetchAuth())
    }
  }, [token])

  const [captchaNo, setCaptchaNo] = useState(generateCaptcha())
  //#endregion

  //#region formik
  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
  //   initialValues,
  //   validationSchema: loginSchema,
  //   onSubmit: async (values) => {
  //     setIsLocalLoading(true);
  //     dispatch(signIn(values))
  //   },
  // });

  const callGovtDeptCodesAPI = async (token) => {
    setViewBackdrop(true);
    try {
      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      const response = await fetch(cfpBaseUrl + "sco/getGovtDepartList", requestOptions);
      const result = await response.json();

      if (result.status === "200") {
        // setGovtDeptCodes(result.data);
        localStorage.setItem("govtDeptCodes", JSON.stringify(result.data)); // ✅ Save to localStorage
      } else {
        console.log("Unexpected status:", result.status);
      }
    } catch (e) {
      console.error("Error calling GovtDeptCodes API:", e);
    } finally {
      setViewBackdrop(false);
    }
  };
  const callStandardClassificaitionCodesAPI = async (token) => {
    setViewBackdrop(true);
    try {
      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      const response = await fetch(cfpBaseUrl + "demandNotice/getClassificationCodes", requestOptions);
      const result = await response.json();

      if (result.status === "200") {
        // setGovtDeptCodes(result.data);
        localStorage.setItem("govtClassFeCodes", JSON.stringify(result.data));
      } else {
        console.log("Unexpected status:", result.status);
      }
    } catch (e) {
      console.error("Error calling GovtDeptCodes API:", e);
    } finally {
      setViewBackdrop(false);
    }
  };

  const finalizeSuccessfulLogin = async (data) => {
    const authToken = data.token;
    dispatch(setUserData(data));
    if (authToken) {
      await callGovtDeptCodesAPI(authToken);
      await callStandardClassificaitionCodesAPI(authToken);
    }
    setIsLocalLoading(false);
    setShowMfa(false);
    setPendingLoginData(null);
    setMfaQrSrc(null);
    setMfaManualSecret('');
    setMfaQrError('');
    setMfaVerifyError('');
  };

  const loginFormik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setIsLocalLoading(true);
      setErrorMessage("");
      setMfaUserId(values.UserName || '');

      try {
        const resultAction = await dispatch(signIn(values));
        const today = new Date().toISOString().split("T")[0];
        localStorage.setItem("appDate", today);
        const data = resultAction.payload;

        if (resultAction.type === 'auth/signIn/rejected') {
          setIsLocalLoading(false);
          setErrorMessage(data || 'Login failed');
          return;
        }

        const token = data.token;
        setUserToken(token);

        const isPasswordChangeRequired =
          data.isPasswordChangeRequired === true ||
          data.isPasswordChangeRequired === 'True';

        if (isPasswordChangeRequired) {
          setIsLocalLoading(false);
          passwordChangeFormik.setFieldValue('iv_old_password', values.Password);
          setShowChangePasswordPopup(true);
          return;
        }

        if (shouldShowMfaStep(data)) {
          setPendingLoginData(data);
          if (data?.requiresQRCode && data?.qrCodeImageBase64String) {
            setMfaQrSrc(`data:image/png;base64,${data.qrCodeImageBase64String}`);
          }
          setShowMfa(true);
          setMfaQrError('');
          setMfaVerifyError('');
          setIsLocalLoading(false);
          return;
        }

        await finalizeSuccessfulLogin(data);

      } catch (error) {
        setIsLocalLoading(false);
        setErrorMessage(error.message || 'Something went wrong');
      }

    },
  });

  const handleMfaVerify = async (otp) => {
    setMfaVerifyLoading(true);
    setMfaVerifyError('');
    try {
      const userForMfa =
        pendingLoginData?.userId ||
        pendingLoginData?.userName ||
        mfaUserId ||
        loginFormik.values?.UserName;
      if (!userForMfa) {
        setMfaVerifyError('UserId not found for MFA verification.');
        return;
      }
      const { status, ok, message, data: body } = await verifyMfaOtp({
        userId: userForMfa,
        otp,
        isLoggedInFromMobile: '1',
      });
      if (String(status) === '200' || ok) {
        const verifiedLoginData = {
          ...(body || {}),
          token: body?.token || pendingLoginData?.token || userToken,
        };

        const isPasswordChangeRequiredAfterVerify =
          verifiedLoginData?.isPasswordChangeRequired === true ||
          verifiedLoginData?.isPasswordChangeRequired === 'True';
        if (isPasswordChangeRequiredAfterVerify) {
          setUserToken(verifiedLoginData?.token || userToken || '');
          setIsLocalLoading(false);
          passwordChangeFormik.setFieldValue('iv_old_password', loginFormik.values.Password);
          setShowMfa(false);
          setPendingLoginData(null);
          setMfaQrSrc(null);
          setMfaManualSecret('');
          setMfaQrError('');
          setMfaVerifyError('');
          setShowChangePasswordPopup(true);
          return;
        }

        await finalizeSuccessfulLogin(verifiedLoginData);
      } else {
        setMfaVerifyError(message || body?.message || 'Verification failed.');
      }
    } catch (e) {
      setMfaVerifyError(`Verification failed: ${e?.message || 'Unknown error'}`);
    } finally {
      setMfaVerifyLoading(false);
    }
  };

  const handleMfaCancel = () => {
    setShowMfa(false);
    setPendingLoginData(null);
    setMfaQrSrc(null);
    setMfaManualSecret('');
    setMfaQrError('');
    setMfaVerifyError('');
    setMfaUserId('');
  };


  const callLogoutAPI = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);


      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        keepalive: true,
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/logOut", requestOptions)
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
    } catch (e) {

    }
  }


  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm } = loginFormik;
  const passwordChangeFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_old_password: Yup.string().required("Old password is required"),
      iv_new_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
      iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_new_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", userToken);

      const formdata = new FormData();
      formdata.append("userName", userId);
      formdata.append("newPassword", values.iv_new_password);
      formdata.append("currentPassword", values.iv_old_password);

      var requestOptions = {
        method: "PUT",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/updateUserPassword",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // if (result.status === "200") {
          //   resetForm();
          //   setUserToken('');
          //   setShowChangePasswordPopup(false)
          //   loginFormik.resetForm();
          //   resetCaptcha();
          //   setShowSuccessSnackbar(true);
          //   // window.location.reload();
          // }
          if (result.status === "200") {
            resetForm();
            setUserToken('');
            loginFormik.resetForm();
            resetCaptcha();

            setShowSuccessSnackbar(true);

            // Delay closing the dialog by 300ms
            setTimeout(() => {
              setShowChangePasswordPopup(false);
            }, 300);
          }
          else if (result.status === "400") {
            setApiError(result.message)
          }
        })
        .catch((error) => console.log("error", error));
      setViewBackdrop(false);
    },
  });
  //#endregion

  //#region functions
  function generateCaptcha() {
    const operators = ['+'];
    const num1 = Math.floor(Math.random() * 20);
    const num2 = Math.floor(Math.random() * 20);
    const operator = operators[Math.floor(Math.random() * operators.length)];

    return `${num1} ${operator} ${num2}`;
  }


  const resetCaptcha = () => {
    setCaptchaNo(generateCaptcha());
    setCaptchaVerified(false);
    setCaptchaInput('');
  };
  const handleCloseChangePasswordPopup = () => {
    setShowChangePasswordPopup(false);
    passwordChangeFormik.resetForm();
    loginFormik.resetForm();
    resetCaptcha();
    setApiError('');
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleCaptchaChange = (e) => {
    const value = e.target.value.trim();
    setCaptchaInput(value);

    // Evaluate the math expression safely
    try {
      const answer = eval(captchaNo); // e.g. "6 - 5" => 1

      if (value === answer.toString()) {
        setCaptchaVerified(true);
      } else {
        setCaptchaVerified(false);
      }


    } catch (error) {
      console.error("Invalid CAPTCHA expression:", captchaNo);
      setCaptchaVerified(false);
    }
  };


  //#endregion

  //#region useEffects
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (error) {
      setShowError(true);
      setIsLocalLoading(false);
    }
  }, [error])

  useEffect(() => {
    dispatch(stopLoading())
  }, [])

  useEffect(() => {
    if (!showMfa || !pendingLoginData?.token) return;
    let cancelled = false;
    (async () => {
      setMfaQrLoading(true);
      setMfaQrError('');
      setMfaQrSrc(null);
      setMfaManualSecret('');
      try {
        const { ok, data: body, status } = await fetchMfaQrSetup(pendingLoginData.token);
        if (cancelled) return;
        if (String(status) === '200' && (body?.data || body?.qrCodeImageBase64String)) {
          const d = body?.data || body;
          let qr = null;
          if (d.qrCodeImageBase64String) qr = `data:image/png;base64,${d.qrCodeImageBase64String}`;
          else if (d.qrImageBase64) qr = `data:image/png;base64,${d.qrImageBase64}`;
          else if (d.qrUrl) qr = d.qrUrl;
          setMfaQrSrc((prev) => prev || qr);
          setMfaManualSecret(d.manualSecret || d.secret || '');
        } else if (!ok) {
          setMfaQrError(body?.message || 'Unable to load QR. API path may need configuration.');
        }
      } catch (e) {
        if (!cancelled) setMfaQrError(e.message || 'QR request failed.');
      } finally {
        if (!cancelled) setMfaQrLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showMfa, pendingLoginData]);

  useEffect(() => {
    const getAllSubDivisions = async (token, hierarchy, code, roleTypeId) => {
      if (token) {
       try {
          await AllSubDivisions(token, hierarchy, code)
          setIsLocalLoading(false)
          //  if (roleTypeId == "1") {
          //   console.log(roleId, 'roleTypeId')
          //   console.log(code, 'roleId,code')
          //   if (roleId == 1151 && code == "10") {
          //     navigate('/top-best-and-worst-performer-users-report')
          //   }
          //   if (CheckPermissions(permissions, 'Dashboard', 'Commercial Operations') ) {
          //     // navigate('/technicalOperations')
          //     navigate('/new-connection-table')
          //   } else if (CheckPermissions(permissions, 'Dashboard', 'CFC Dashboard')) {
          //     navigate('/homecfc')
          //   } else {
          //     navigate('/new-connection-table')
          //   }
          // } else if (roleTypeId == "2") {
          //   if (CheckPermissions(permissions, 'Dashboard', 'Operational Performance')) {
          //     navigate('/technicalOperations', { state: { officeCode: code } })
          //   } else if (CheckPermissions(permissions, 'Dashboard', 'Field Office Dashboard')) {
          //     navigate('/new-connection-table', { state: { officeCode: code } })
          //   } else if (CheckPermissions(permissions, 'General Services', 'New Connection')) {
          //     navigate('new-connection-table')
          //   } else if (CheckPermissions(permissions, 'General Services','Meter Change Order')) {
          //     navigate('meter-change-request-table')
          //   }else if (CheckPermissions(permissions, 'General Services', 'Reconnection')) {
          //     navigate('reconnection-table')
          //   } else if (CheckPermissions(permissions, 'Power Complaints')) {
          //     navigate('/technicalOperations')
          //   } else if (CheckPermissions(permissions, 'Access Management')) {
          //     navigate('user-management')
          //   }
          navigate('/landingpage')
        } catch (e) {
          console.log(e, 'error calling sub division')
        }
      }
    }

    if (userId) {
      if (code == 10 && roleId == '1151') {
        getAllSubDivisions(token, hierarchy, 10, roleTypeId)
      } else if (code == 10 && roleId != '1151') {
        getAllSubDivisions(token, hierarchy, 15, roleTypeId)
      } else {
        getAllSubDivisions(token, hierarchy, code, roleTypeId)
      }
    }
  }, [userId, navigate]);

  useEffect(() => {
    if (code) {
      dispatch(updateOC({ officeCode: code }))
    }
  }, [code])

  //#endregion

  return (
    <Grid className='login-background'>
      {isLoading ?
        <div className="splash">
          <img className="animated" src={eOpsLogo} alt="" />
        </div> :
        <form className='loginForm'>
          <div className='logoContainer' >
            <img src={eOpsLogo} alt="" className='logo' />
          </div>
          {
            showError &&
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '70%', backgroundColor: '#FFF3F3', margin: 'auto', padding: '2% 5%', borderRadius: '5px' }}>
              <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center' }}>
                <ErrorIcon style={{ color: '#bb0303', marginRight: '10px' }} />
                <p style={{ color: '#bb0303' }}>{error && <p>{error}</p>}</p>
              </div>
              <CloseIcon sx={{ color: '#bb0303', cursor: 'pointer' }} onClick={() => { setShowError(false) }
              } />
            </div>
          }
          <Box className='form-fields'>
            <TextField
              margin="normal"
              className='textfield'
              required
              fullWidth
              value={values.UserName}
              name="UserName"
              onChange={handleChange}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <EmailIcon className='icon' />
                  </InputAdornment>
                ),
                autoComplete: "off"
              }}
              id="username"
              label=""
              autoComplete="off"
              placeholder='Username'
              size='small'
            />
            {errors.UserName && touched.UserName ? (
              <p className="form-error">{errors.UserName}</p>
            ) : null}
            <TextField
              type={showPassword ? 'text' : 'password'}
              margin="normal"
              className='textfield'
              required
              fullWidth
              value={values.Password}
              name="Password"
              autoComplete="off"
              onChange={handleChange}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <LockIcon className='icon' />
                  </InputAdornment>
                ),
                autoComplete: 'off',
                endAdornment: (
                  <InputAdornment position="end" className='input-adornments'>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              id="password"
              label=""
              placeholder='Password'
              size='small'
            />
            {errors.Password && touched.Password ? (
              <p className="form-error">{errors.Password}</p>
            ) : null}
            {/* <div className='captcha' onClick={(e) => { e.preventDefault(); setCaptchaNo(generateCaptcha()); setCaptchaVerified(false); }}>
              <img src={captcha} alt='captcha' height={30} />
              <div style={{ fontFamily: 'Captcha', transform: 'skew(20deg)' }}>
                {captchaNo}
              </div>
            </div>
            <div style={{ width: '100%', }}>
              <TextField
                type="text"
                margin="normal"
                className="textfield"
                required
                fullWidth
                name="Captcha"
                autoComplete="off"
                value={captchaInput}
                onChange={handleCaptchaChange}
                id="captcha"
                label=""
                placeholder="Captcha"
                size="small"
              />
            </div> */}
            <div style={{ display: 'flex', width: '100%', gap: '10px', alignItems: 'center' }}>
              {/* CAPTCHA box */}
              <div
                className='captcha'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '65%', // adjust to make room for "="
                  cursor: 'pointer',
                  border: '1px solid #ccc',
                  padding: '8px',
                  height: '30px', // match TextField height
                  marginTop: '8px',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setCaptchaNo(generateCaptcha());
                  setCaptchaVerified(false);
                }}
              >
                <img src={captcha} alt='captcha' height={30} />

                <div style={{ fontFamily: 'Captcha', transform: 'skew(20deg)', fontSize: '18px' }}>
                  {captchaNo}
                </div>
              </div>

              {/* Equal sign */}
              <div style={{ width: '5%', textAlign: 'center', fontSize: '20px', marginTop: '8px' }}>
                =
              </div>

              {/* Input field */}
              <div style={{ width: '40%' }}>
                <TextField
                  type="text"
                  margin="normal"
                  className="textfield"
                  required
                  fullWidth
                  name="Captcha"
                  autoComplete="off"
                  value={captchaInput}
                  onChange={handleCaptchaChange}
                  id="captcha"
                  label=""
                  placeholder="Captcha"
                  size="small"
                />
              </div>
            </div>


            <Button
              type="submit"
              fullWidth
              variant="contained"
              className='form-button'
              onClick={loginFormik.handleSubmit}
              disabled={(!captchaVerified) || loading || isLocalLoading}
              sx={{ background: (!captchaVerified || loading || isLocalLoading) ? '#FFFFFF' : '#006ad1', textTransform: 'capitalize' }}
            >
              {(loading || isLocalLoading) ? (
                <Box sx={{ display: 'flex' }}>
                  <CircularProgress color='inherit' size='1.7rem' />
                </Box>
              ) : (
                'Sign in'
              )}
            </Button>
            <Grid className='powered-by'>
              {/* <Box className='form-bottom-link'>
                <Link to="/forgot-password"  >
                  Forgot Password?
                </Link>
              </Box> */}
              <Grid className='logos'>
                <img className='usaid' src={usLogo} alt="" />
                <img className='pitc' src={pitcLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
        </form>
      }

      <Dialog
        open={Boolean(showMfa && pendingLoginData)}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            handleMfaCancel();
          }
        }}
        maxWidth={false}
        fullWidth
        scroll="paper"
        className="mfa-setup-dialog"
        sx={{ zIndex: (theme) => theme.zIndex.modal + 100 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 57, 113, 0.72)',
            backdropFilter: 'blur(3px)',
          },
        }}
        PaperProps={{
          elevation: 12,
          sx: {
            maxWidth: 'min(1120px, calc(100vw - 32px))',
            width: '100%',
            margin: '16px',
            borderRadius: '12px',
            maxHeight: 'calc(100vh - 40px)',
            overflow: 'hidden',
            boxShadow: '0 12px 48px rgba(0, 36, 73, 0.28)',
            border: '1px solid rgba(255, 255, 255, 0.85)',
          },
        }}
      >
        <DialogContent sx={{ p: 0, overflow: 'auto', maxHeight: 'calc(100vh - 40px)' }}>
          {showMfa && pendingLoginData ? (
            <MfaStep
              variant="dialog"
              qrSrc={mfaQrSrc}
              manualSecret={mfaManualSecret}
              qrLoading={mfaQrLoading}
              qrError={mfaQrError}
              verifying={mfaVerifyLoading}
              verifyError={mfaVerifyError}
              onVerify={handleMfaVerify}
              onCancel={handleMfaCancel}
            />
          ) : null}
        </DialogContent>
      </Dialog>

      {showChangePasswordPopup && (
        <Dialog
          open={showChangePasswordPopup}
          onClose={handleCloseChangePasswordPopup}
          fullWidth={true}
          maxWidth="xs"
          className="alert-popups"
        >
          <DialogTitle
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
            className="dialog-title"
          >
            Reset Password
            <Box sx={{ marginTop: "1%" }}>
              <CloseIcon
                id="clearPopup"
                onClick={handleCloseChangePasswordPopup}
                sx={{ color: "white", cursor: "pointer" }}
              />
            </Box>
          </DialogTitle>
          <DialogContent className="dialog-content">
            <DialogContentText component="div">
              <form
                autoComplete="off"
                name="change-password-form"
                onSubmit={passwordChangeFormik.handleSubmit}
              >
                {/* Hidden input to help browser associate correctly */}
                <input
                  type="text"
                  name="username"
                  autoComplete="username"
                  value={UserId}
                  readOnly
                  hidden
                />

                <Grid container sx={{ padding: "20px" }}>
                  <Grid item lg={12}>
                    <Grid container spacing={1}>
                      <Grid item lg={12}>
                        <Typography
                          sx={{
                            backgroundColor: "#FFC0CB",
                            color: "#bb0303",
                            padding: "10px 15px",
                            borderRadius: "5px",
                            fontSize: "0.95rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          ⚠ Your current password has expired. Please set a new
                          password to continue.
                        </Typography>
                      </Grid>

                      {/* New Password Field */}
                      <Grid item lg={12}>
                        <label>New Password</label>
                        <TextField
                          type={
                            passwordChangeFormik.values.iv_new_password
                              ? showNewPassword
                                ? "text"
                                : "password"
                              : "text"
                          }
                          name="iv_new_password"
                          autoComplete="off"
                          value={passwordChangeFormik.values.iv_new_password}
                          onChange={passwordChangeFormik.handleChange}
                          onBlur={passwordChangeFormik.handleBlur}
                          sx={{
                            width: "100%",
                            ".MuiInputBase-input": {
                              height: ".5vh",
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowNewPassword}
                                  edge="end"
                                >
                                  {!showNewPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {passwordChangeFormik.errors.iv_new_password &&
                          passwordChangeFormik.touched.iv_new_password && (
                            <p
                              style={{
                                color: "#f73232",
                                fontSize: "1rem",
                              }}
                            >
                              {passwordChangeFormik.errors.iv_new_password}
                            </p>
                          )}
                      </Grid>

                      {/* Confirm Password Field */}
                      <Grid item lg={12}>
                        <label>Confirm New Password</label>
                        <TextField
                          type={
                            passwordChangeFormik.values.iv_confirm_password
                              ? showConfirmPassword
                                ? "text"
                                : "password"
                              : "text"
                          }
                          name="iv_confirm_password"
                          autoComplete="off"
                          value={passwordChangeFormik.values.iv_confirm_password}
                          onChange={passwordChangeFormik.handleChange}
                          onBlur={passwordChangeFormik.handleBlur}
                          sx={{
                            width: "100%",
                            ".MuiInputBase-input": {
                              height: ".5vh",
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowConfirmPassword}
                                  edge="end"
                                >
                                  {!showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {passwordChangeFormik.errors.iv_confirm_password &&
                          passwordChangeFormik.touched.iv_confirm_password && (
                            <p
                              style={{
                                color: "#f73232",
                                fontSize: "1rem",
                              }}
                            >
                              {passwordChangeFormik.errors.iv_confirm_password}
                            </p>
                          )}
                      </Grid>

                      {/* Error Box */}
                      <Grid item lg={12}>
                        {apiError && (
                          <Error
                            error={apiError}
                            onClose={errorCloses}
                            backgroundColor="#FFC0CB"
                            textColor="#bb0303"
                            iconColor="#bb0303"
                          />
                        )}
                      </Grid>

                      {/* Submit */}
                      <Grid
                        item
                        lg={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          sx={{ width: "30%" }}
                          variant="contained"
                          size="medium"
                          type="submit"
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}

      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          Updated Successfully
        </Alert>
      </Snackbar>

    </Grid>

  );
}

export default Login;